import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const linkKeys = [
  { key: 'footer.links.cli', href: '/cli' },
  { key: 'footer.links.ci', href: '/ci' },
  { key: 'footer.links.contact', href: '/contact' },
  { key: 'footer.links.terms', href: '/terms' },
  { key: 'footer.links.privacy', href: '/privacy' },
];

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="border-t border-slate-800/50 bg-slate-950">
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-col items-start gap-8 md:flex-row md:items-center md:justify-between">
          <div>
            <Link to="/" className="text-lg font-display font-bold">
              <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">
                {t('brand')}
              </span>
            </Link>
            <p className="mt-2 text-sm text-slate-500">
              {t('footer.tagline')}
            </p>
          </div>
          <div className="flex gap-6">
            {linkKeys.map((link) => (
              <Link
                key={link.key}
                to={link.href}
                className="text-sm text-slate-500 hover:text-slate-300 transition-colors"
              >
                {t(link.key)}
              </Link>
            ))}
          </div>
        </div>
        <div className="mt-12 border-t border-slate-800/50 pt-6 text-center text-sm text-slate-600">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </div>
      </div>
    </footer>
  );
}
